import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SimpleLookupResult } from '../../../type-definitions/general/general';
import { ReportParameterValue } from '../../../type-definitions/reportGateway/requests/reportGateway';
import { ReportParameters } from '../../../type-definitions/reportGateway/responses/reportGateway';

@Injectable({
  providedIn: 'root',
})
export class ReportGatewayService {
  constructor(private http: HttpClient) {}

  getLookupData(reportID: number, paramName: string, paramData: ReportParameterValue[]): Promise<SimpleLookupResult[]> {
    const url = '/ReportGateway/GetLookupData';
    return this.http
      .post<SimpleLookupResult[]>(url, {
        reportID: reportID,
        paramName: paramName,
        paramData: paramData,
      })
      .toPromise();
  }

  getReports(reportID, moduleShortName, company = null) {
    const url =
      '/ReportGateway/GetReports' +
      (reportID != null ? '?reportID=' + reportID : '') +
      (moduleShortName != null ? '?moduleShortName=' + moduleShortName : '') +
      (company != null ? '&company=' + company : '');
    return this.http.get(url).toPromise();
  }

  getReportParameters(reportID) {
    const httpParams = new HttpParams().set('reportID', reportID);
    const url = '/ReportGateway/GetReportParameters';
    return this.http.get<ReportParameters[]>(url, { params: httpParams }).toPromise();
  }

  loadReport(Params, ReportID, PorOrLan, fileType, ReportName) {
    const url = '/ReportGateway/LoadReport';
    return this.http
      .post(url, {
        Params: Params,
        ReportID: ReportID,
        PorOrLan: PorOrLan,
        fileType: fileType,
        ReportName: ReportName,
      })
      .toPromise();
  }

  setParamCache(params) {
    return this.http.post('/ReportGateway/SetParamCache', { rptParams: params }).toPromise();
  }

  reportTrack(reportID, reportName, params) {
    return this.http.post('/ReportGateway/ReportTrack', { reportID: reportID, reportName: reportName, reportParams: params }).toPromise();
  }

  getVistaAttachment(attachmentId, rid, rsid) {
    const url = '/ReportGateway/GetVistaAttachment?attachmentId=' + attachmentId + '&rid=' + rid + '&rsid=' + rsid;
    return this.http.get(url).toPromise();
  }
}
